import { Outlet } from 'react-router-dom'
import { BackButtonSync } from './BackButtonSync'
import { BottomTabs } from './BottomTabs'
import { TopBar } from './TopBar'
import { PaywallModal } from '../paywall/PaywallModal'

export function AppShell() {
  return (
    <div className="min-h-dvh bg-cream pb-28">
      <BackButtonSync />
      <TopBar />
      <main className="mx-auto max-w-md px-4 pt-3">
        <Outlet />
      </main>
      <BottomTabs />
      <PaywallModal />
    </div>
  )
}
